import { render } from "./ShoppingBag.vue?vue&type=template&id=025877ce"
import script from "./ShoppingBag.vue?vue&type=script&lang=js"
export * from "./ShoppingBag.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "025877ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('025877ce', script)) {
    api.reload('025877ce', script)
  }
  
  module.hot.accept("./ShoppingBag.vue?vue&type=template&id=025877ce", () => {
    api.rerender('025877ce', render)
  })

}

script.__file = "src/icons/components/filled/ShoppingBag.vue"

export default script